import type { SchemaData } from '@lemonade-hq/chat-engine';
import { PLATFORM_UI_ATTRIBUTE, THEME_BRAND_ATTRIBUTE, THEME_SCHEME_ATTRIBUTE } from '@lemonade-hq/uniclient-chat';
import { isNativeApp } from '@lemonade-hq/uniclient-mobile-bridge';
import { useTheme } from '@lemonade-hq/uniclient-theme';
import deepmerge from 'deepmerge';
import { useCallback, useEffect, useState } from 'react';

export enum PlatformType {
  Web = 'web',
  Native = 'native',
}

export interface UIAttributesProps {
  readonly [PLATFORM_UI_ATTRIBUTE]: PlatformType;
}

export const WIZARD_DEFAULT_UI_ATTRIBUTES: (keyof UIAttributesProps)[] = [PLATFORM_UI_ATTRIBUTE];

export interface WizardUiAttributesContext {
  readonly uiAttrs: SchemaData;
  readonly updateUiAttrs: React.Dispatch<React.SetStateAction<SchemaData>>;
}

export function useWizardUiAttributes(): WizardUiAttributesContext {
  const platform = isNativeApp() ? PlatformType.Native : PlatformType.Web;
  const { theme } = useTheme();
  const [uiAttrs, setUiAttrs] = useState<SchemaData>({
    [PLATFORM_UI_ATTRIBUTE]: platform,
    [THEME_SCHEME_ATTRIBUTE]: theme.scheme,
    [THEME_BRAND_ATTRIBUTE]: theme.brand,
  });

  const updateUiAttrs = useCallback((newUiAttrs: SchemaData) => {
    setUiAttrs(oldUiAttrs => deepmerge(oldUiAttrs, newUiAttrs));
  }, []);

  useEffect(() => {
    setUiAttrs(oldUiAttrs =>
      deepmerge(oldUiAttrs, { [THEME_SCHEME_ATTRIBUTE]: theme.scheme, [THEME_BRAND_ATTRIBUTE]: theme.brand }),
    );
  }, [theme]);

  return { uiAttrs, updateUiAttrs };
}
